import { useQuery } from '@tanstack/react-query';
import { getSidebarStories, SidebarStory } from '../services/api.ts';

// Only track simple lifecycle states in the dropdown: queued → processing → completed
const IN_PROGRESS = new Set([
  'queued',
  'processing'
]);

export function useSidebarStories() {
  return useQuery<SidebarStory[]>({
    queryKey: ['sidebar-stories'],
    queryFn: getSidebarStories,
    staleTime: 60_000,
    placeholderData: (prev) => prev,         // prevents flicker on background refetch
    refetchOnWindowFocus: false,
    refetchInterval(query) {
      const data = query.state.data as SidebarStory[] | undefined;
      return data?.some(s => IN_PROGRESS.has(s.status ?? '')) ? 3000 : false;
    },
  });
}
